<div class="dialog container-fluid no-padding col-md-12 display-flex">
    <div class="grey  col-md-6">
        <div class="row">
            <img class="pr-2 pointer" src="assets/svg/right-arrow.svg" alt="" (click)="previousPart()">
            <h6 class="pl-2 pr-2 mt-2">Part {{currentIndex+1}} of {{vendorOrderItems.length}}</h6>
            <img class="pl-2 pointer" src="assets/svg/left-arrow.svg" alt="" (click)="nextPart()">
        </div>
        <div class="thumbnail mt-4">
            <img class="pointer"
                [src]="partDetails?.thumbnail ? partDetails?.thumbnail : 'assets/svg/truventor_loader.svg'"
                (click)="viewer()" alt="part details image">
        </div>
        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">PART ID:</p>&nbsp;&nbsp;
                <h6 class="mb-0 medium">{{partDetails?.model_attributes?.model_code}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">PART NAME:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.model_attributes?.file_name}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">L x B x H:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.cleaned_model_attributes?.length}}mm&nbsp;x&nbsp;{{partDetails?.cleaned_model_attributes?.width}}mm&nbsp;x&nbsp;{{partDetails?.cleaned_model_attributes?.height}}mm
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">VOLUME:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.cleaned_model_attributes?.volume}}mm</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">AREA:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.cleaned_model_attributes?.surface_area}}mm</h6>
            </div>
        </div>
        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">TECHNOLOGY:</p>&nbsp;&nbsp;
                <h6 class=" medium mb-0">{{partDetails?.technology_name}}</h6>
            </div>
            <div *ngIf="partDetails?.sub_technology_details?.name" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SUB TECHNOLOGY:</p>&nbsp;&nbsp;
                <h6 class=" medium mb-0">{{partDetails?.sub_technology_details ?
                    partDetails?.sub_technology_details?.name : '--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">MATERIAL:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.material_name}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE FINISH:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_surface_finishing?.name ? partDetails?.material_surface_finishing?.name :
                    '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE COLOR:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_surface_finishing?.color ? partDetails?.material_surface_finishing?.color :
                    '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE TREATMENT:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_heat_treatment?.name ? partDetails?.material_heat_treatment?.name : '--'}}
                </h6>
            </div>

            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE HARDNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.shore_hardness?.name ? partDetails?.shore_hardness?.name : '--'}}
                </h6>
            </div>

            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE ROUGHNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.surface_roughness?.name ? partDetails?.surface_roughness?.name : '--'}}
                </h6>
            </div>
            <!-- <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE HARDNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.sheet_thickness? partDetails?.sheet_thickness:'--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE ROUGHNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.sheet_thickness? partDetails?.sheet_thickness:'--'}}</h6>
            </div> -->

        </div>
        <!-- !:##################################### Other options ############################################## -->
        <div class="mt-3 sub">
            <!-- <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE HARDNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.shore_hardness? partDetails?.shore_hardness?.name:'--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE ROUGHNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.surface_roughness? partDetails?.surface_roughness?.name:'--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">DEBURRING:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.deburring ? partDetails?.deburring : '--'}} 
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">RELIEF CUTS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.reliefcuts ? partDetails?.reliefcuts : '--'}} 
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">ROLLING / GRINDING DIRECTION:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.rollinggrinding ? partDetails?.rollinggrinding : '--'}} 
                </h6>
            </div> -->
            <div *ngIf="partDetails?.thickness?.thickness" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">THICKNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.thickness?.thickness ? partDetails?.thickness?.thickness : '--'}}

                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">TOLERANCE:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.tolerance?.name ? partDetails?.tolerance?.name : '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">THREADED HOLES:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.taps?.name ? partDetails?.taps?.name : '--'}}
                </h6>
            </div>

            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">ADDITIONAL INSTRUCTIONS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.instructions}}</h6>
            </div>
        </div>
        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">INSPECTION TYPE:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.inspection ? partDetails?.inspection?.name : '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SCRAP MATERIAL:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.scrap_material_option_id==1 ? 'Keep' : 'Discard'}}
                </h6>
            </div>
            <div *ngIf="partDetails?.quality_control_params?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">QUALITY CONTROL PARAMS:</p>
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let param of partDetails?.quality_control_params">
                        <li class="ps-2">{{ param?.quality_checklist }}</li>
                    </ng-container>
                </h6>
            </div>
            <div *ngIf="partDetails?.reports?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">REPORTS:</p>
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let report of partDetails?.reports; let j=index">
                        <li class="ps-2">{{ report?.name }}</li>
                    </ng-container>
                </h6>
            </div>
            <div *ngIf="partDetails?.certificates?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">CERTIFICATES:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let certificate of partDetails?.certificates; let i=index">
                        <li class="ps-2">{{ certificate?.name }}</li>
                    </ng-container>
                </h6>
            </div>
        </div>
        <div class="container-fluid no-padding ml-0 row mt-2">
            <p class="mb-0">3D Files:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadModelFile()">{{partDetails?.model_attributes?.file_name}}</a>
        </div>
        <div class="container-fluid no-padding ml-0 row mt-1">
            <p class="mb-0">2D Files:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadDrawing()">Download All</a>
        </div>
        <div class="container-fluid no-padding ml-0 row mt-1"
            *ngIf="partDetails?.inspection?.name?.toLowerCase() === 'custom'">
            <p class="mb-0">CUSTOM INSPECTION FILES:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadCustomInspectionFile()">Download All</a>
        </div>
        <!-- <div class="container-fluid no-padding ml-0 row mt-2">
            <h6 class="regular">INSTRUCTIONS:</h6>&nbsp;&nbsp;
            <p class="col-md-10 pl-0 pr-0">{{partDetails?.instructions}} </p>
        </div> -->

    </div>
    <div class="white col-md-6">
        <div class="loaderDiv" *ngIf="!partDetails">
            <img src="assets/svg/truventor_loader.svg">
        </div>
        <form *ngIf="partDetails" [formGroup]="costUpdateForm">

            <mat-tab-group (selectedTabChange)="onTabChange($event)" animationDuration="0ms" disableRipple="true" class="inspection-tab-label">
                <mat-tab *ngFor="let bid_item_batch of bidItemBatchesArray.controls; let i=index">
                    <ng-template mat-tab-label>
                        {{bid_item_batch?.value?.name}}
                    </ng-template>
                    <div [formGroup]="bid_item_batch">
                        <div class="content custom-form px-2 pt-2">
                            <h6>Enter Bidding Values:</h6>
                            <div class="mt-4 row col-md-12">
                                <p class="medium col-md-8 mb-0">Item Rate({{currency}}):
                                    <span class="required-asterisk">*</span>
                                </p>
                                <input class="col-md-4 bg-white" type="text" formControlName="item_rate"
                                    (change)="itemRateChange(bid_item_batch.value.id)">
                            </div>
                            <!-- <div class="col-md-12 yellow mt-2">
                                    <p class="light mb-0">Target Price is: &nbsp;&nbsp; <span class="medium">100INR</span></p>
                                </div> -->
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Quantity:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch.value?.dispatch_quantity}}</h6>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Agreed Quantity:
                                    <span class="required-asterisk">*</span>
                                </p>
                                <input class="col-md-4 bg-white" (change)="itemRateChange(bid_item_batch.value.id)"
                                    type="number" formControlName="agreed_quantity"
                                    min="0"
                                    [max]="bid_item_batch.value?.dispatch_quantity">
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Sub Total</p>
                                <h6 class="medium col-md-4">{{partDetails.dispatch_batch[i]?.sub_total | currency:currency}}</h6>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">HSN Code:
                                    <span class="required-asterisk">*</span>
                                </p>
                                <input class="col-md-4 bg-white" type="text" formControlName="hsn_code">
                            </div>
                            <!-- <div class="mt-3 row taxhide">
                                    <p class="medium col-md-8 mb-0">Taxation %:</p>
                                    <input class="col-md-4" type="text" formControlName="taxation">
                                </div> -->
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Taxation %:</p>
                                <input class="col-md-4" type="text" (change)="itemRateChange(bid_item_batch.value.id)"
                                    formControlName="taxation">
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Batch Total:</p>
                                <h6 class="medium col-md-4">{{partDetails.dispatch_batch[i]?.total_cost | currency:currency}}</h6>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Tentative Bid Award Date:</p>
                                <h6 class="medium col-md-4">{{partDetails?.tentative_quote_award_date ?
                                    (partDetails.tentative_quote_award_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Expected Delivery Date:</p>
                                <h6 class="medium col-md-4">{{partDetails.dispatch_batch[i]?.dispatch_date ?
                                    (partDetails.dispatch_batch[i]?.dispatch_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-12 mb-0">Actual Delivery Date:
                                    <span class="required-asterisk">*</span>
                                </p>
                                <div class="col-md-12 pe-0">
                                    <mat-form-field class="actualDeliveryDate" appearance="outline">
                                        <input matInput [matDatepicker]="picker1" 
                                        readonly 
                                        formControlName="actual_date"
                                        (dateInput)="OnDateChange($event, i)" 
                                        placeholder="Actual Date"
                                        [min]="partDetails?.tentative_quote_award_date">
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="mt-3 row col-md-12">
                                <p class="medium col-md-8 mb-0">Time(Lead Days):</p>
                                <input [(ngModel)]="costUpdateForm.value['bid_item_batches'][i]['time']" readonly aria-readonly="" class="col-md-4  bg-white" type="text" formControlName="time">
                            </div>
                            
                            <div class="custom-form comment">
                                <h6 class="medium mt-2  bg-white">Comment</h6>
                                <input placeholder="Add a comment" class="col-md-12" type="text"
                                    formControlName="vendor_comments">
                            </div>
                            <br>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>


            <div class="footer">
                <button class="btn-white mr-2 " (click)="close()">Cancel</button>
                <button class="orange ml-2" (click)="submitCost()">Submit</button>
            </div>
        </form>
    </div>
</div>